import Button from "components/common/Button/Button";
import Content from "components/Content";
import { Row } from "react-grid-system";
import styled from "styled-components";

interface IProps {
  itemsInRow: number;
}

export const StyledContent = styled(Content)`
  margin: 0 !important;
  background: transparent !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
`;

export const TitleRow = styled(Row)`
  position: absolute;
  width: 100%;
  margin-top: -10vh;
`;

export const GridRow = styled.div`
  display: grid;
  ${({ itemsInRow }: IProps) => `
    grid-template-columns: repeat(${itemsInRow}, 20vh);
  `}
  grid-auto-rows: 20vh;
  grid-gap: 1rem;
  margin-bottom: 1rem;

  &::before {
    content: "";
    width: 0;
    padding-bottom: 100%;
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }

  > *:first-child {
    grid-row: 1 / 1;
    grid-column: 1 / 1;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/ElementSelector.style.tsx